import { clsx } from 'clsx';
import type { HTMLAttributes } from 'react';

type Props = HTMLAttributes<HTMLDivElement> & {
  tone?: 'plain' | 'debit' | 'credit' | 'accent' | 'warn';
};

const toneClass: Record<NonNullable<Props['tone']>, string> = {
  plain:  'bg-cream border-ink-200/80',
  debit:  'bg-debit-100/40 border-debit-200',
  credit: 'bg-credit-100/40 border-credit-200',
  accent: 'bg-accent-50 border-accent-200',
  warn:   'bg-warn-100/40 border-warn-200',
};

export function Card({ tone = 'plain', className, ...rest }: Props) {
  return (
    <div
      {...rest}
      className={clsx('rounded-card border shadow-card p-4', toneClass[tone], className)}
    />
  );
}
